<template>
  <div>
    <!-- Hide temporarily -->
    <!-- <div class="d-flex justify-space-between px-6 mt-3">
      <div v-if="showTextInformation">
        Klik pada bagian tubuh yang ingin anda berikan tanda
      </div>
      <div v-else></div>
      <div class="controls">
        <v-btn
          text
          small
          color="primary"
          class="text-none"
          @click="$emit('toggle-show-all')"
        >
          <v-icon left small>mdi-eye-outline</v-icon>
          Tampilkan Keterangan
        </v-btn>
        <v-btn
          icon
          class="square-rounded-btn mr-1"
          color="primary"
          outlined
          @click="$emit('navigate-body-part', 'previous')"
        >
          <v-icon>mdi-chevron-left</v-icon>
        </v-btn>
        <v-btn
          icon
          class="square-rounded-btn ml-1"
          color="primary"
          outlined
          @click="$emit('navigate-body-part', 'next')"
        >
          <v-icon>mdi-chevron-right</v-icon>
        </v-btn>
      </div>
    </div> -->

    <div class="mt-6 container-image">
      <!-- Full Body -->
      <div class="outline-img mark-body">
        <v-stage
          :config="getStageConfig('mark_body')"
          class="operation-stage"
          ref="mark_body"
          @click="handleInputMark($event, 'mark_body')"
        >
          <v-layer>
            <v-image :config="getImageConfig('mark_body')" />
            <v-group
              v-for="item in getMarksForBodyPart('mark_body')"
              :key="item.id"
              @mouseover="showTooltip($event, item)"
              @mouseout="hideTooltip"
            >
              <v-circle :config="getCircleConfig(item)" />
              <v-text :config="getTextConfig(item, item.idx + 1)" />
              <!-- <v-text :config="getTextConfig(item, item.idx + 1)" /> -->
            </v-group>
          </v-layer>
        </v-stage>
      </div>

      <!-- Body Parts Grid -->
      <div class="grid-column">
        <div
          v-for="bodyPart in bodyParts"
          :key="bodyPart.key"
          class="outline-img column"
        >
          <v-stage
            :config="getStageConfig(bodyPart.key)"
            class="operation-stage"
            :ref="bodyPart.key"
            @click="handleInputMark($event, bodyPart.key)"
          >
            <v-layer>
              <v-image :config="getImageConfig(bodyPart.key)" />
              <v-group
                v-for="item in getMarksForBodyPart(bodyPart.key)"
                :key="item.id"
                @mouseover="showTooltip($event, item)"
                @mouseout="hideTooltip"
              >
                <v-circle :config="getCircleConfig(item)" />
                <v-text :config="getTextConfig(item, item.idx + 1)" />
              </v-group>
            </v-layer>
          </v-stage>
        </div>
      </div>
    </div>

    <!-- MOVED COMPONENTS START HERE -->
    <anatomical-card-form
      v-if="menu"
      :markIdx="markInputIdx"
      :data="marks[markInputIdx]"
      :x="menuPosition.x"
      :y="menuPosition.y"
      :injuryItem="injuryTypes"
      :isDoctor="isDoctor"
      @close="closeCardForm(idx)"
      @save="saveInput"
      @delete="deleteMark(markInputIdx)"
    />
    <!-- @save="$emit('save-card', $event)" -->
    <single-tooltip-mark
      :hoveredMark="hoveredMark"
      :tooltipPosition="tooltipPosition"
      :show="showTooltipVar"
    />
    <!-- MOVED COMPONENTS END HERE -->
  </div>
</template>

<script>
// Import the moved components
import AnatomicalCardForm from '../AnatomicalCardForm.vue';
import SingleTooltipMark from './SingleTooltipMark.vue';

import mark_body_maleSVG from '@/assets/image/mark_body_male_image.svg';
import mark_body_femaleSVG from '@/assets/image/mark_body_female_image.svg';
import mark_face_frontSVG from '@/assets/image/mark_face_front_image.svg';
import mark_face_sideSVG from '@/assets/image/mark_face_side_image.svg';
import mark_palm_upperSVG from '@/assets/image/mark_palm_upper_image.svg';
import mark_palm_lowerSVG from '@/assets/image/mark_palm_lower_image.svg';
import mark_foot_upperSVG from '@/assets/image/mark_foot_upper_image.svg';
import mark_foot_lowerSVG from '@/assets/image/mark_foot_lower_image.svg';

// import Constant from '@/const';
// const axios = require('axios');

// Constants
const SCALE_FACTOR = 1.08;
const IMAGE_OFFSET = 7;
const CIRCLE_RADIUS = 12;
const CIRCLE_COLOR = '#1976D2';
const TEXT_COLOR = '#FFFFFF';

const IMAGE_CONFIGS = [
  {
    key: 'mark_body',
    width: 472.61,
    height: 483.425,
    getSrc: gender =>
      gender === 'Laki-laki' || gender === true
        ? mark_body_maleSVG
        : mark_body_femaleSVG,
  },
  {
    key: 'mark_face_front',
    src: mark_face_frontSVG,
    width: 240,
    height: 122.949,
  },
  {
    key: 'mark_face_side',
    src: mark_face_sideSVG,
    width: 240,
    height: 118.786,
  },
  {
    key: 'mark_palm_upper',
    src: mark_palm_upperSVG,
    width: 240,
    height: 140.794,
  },
  {
    key: 'mark_palm_lower',
    src: mark_palm_lowerSVG,
    width: 240,
    height: 141.151,
  },
  {
    key: 'mark_foot_upper',
    src: mark_foot_upperSVG,
    width: 160,
    height: 136.543,
  },
  {
    key: 'mark_foot_lower',
    src: mark_foot_lowerSVG,
    width: 160,
    height: 154.783,
  },
];

export default {
  name: 'AnatomyMarkerContent',
  // Register the moved components
  components: {
    AnatomicalCardForm,
    SingleTooltipMark,
  },
  props: {
    // Existing props
    marksProp: { type: Array, required: true },
    gender: { type: Boolean, default: false },
    isDoctor: { type: Boolean, default: false },
    tooltipMode: { type: String, default: 'none' },
    injuryTypes: { type: Array, default: () => [] },
    readonly: { type: Boolean, default: false },
    showTextInformation: { type: Boolean, default: true },
  },
  watch: {
    marksProp() {
      this.mapInitialData();
    },
  },
  data() {
    return {
      backgroundMark: {},
      isLoading: true,
      hoveredMark: null,
      tooltipPosition: { x: 0, y: 0 },
      showTooltipVar: false,
      menu: false,
      menuPosition: { x: 0, y: 0 },
      markInputIdx: null,
      marks: [],
      globalMarkIndex: 0,
    };
  },
  computed: {
    bodyParts() {
      return IMAGE_CONFIGS.filter(config => config.key !== 'mark_body');
    },
  },
  async created() {
    await this.loadImages();
  },
  mounted() {
    this.mapInitialData();
  },
  methods: {
    mapInitialData() {
      if (this.marksProp) {
        this.globalMarkIndex = this.marksProp.length;
        this.marks = this.marksProp;
      }
    },
    saveInput(mark) {
      this.marks[this.markInputIdx] = {
        ...this.marks[this.markInputIdx],
        ...mark,
      };
      this.$emit('save', this.marks[this.markInputIdx]);
      this.closeCardForm();
    },
    closeCardForm(index = null) {
      const markLength = this.marks.length;
      if (index !== null && index + 1 === markLength) {
        this.marks.pop();
      }
      this.globalMarkIndex = this.marks.length;
      this.menu = false;
    },
    deleteMark(markIdx) {
      this.marks.splice(markIdx, 1);
      this.reIndexMarks();
      this.closeCardForm(null);
    },
    reIndexMarks() {
      this.marks = this.marks.map((v, i) => ({ ...v, idx: i }));
    },
    handleInputMark(event, bodyPartKey) {
      if (this.readonly) return;
      const stage = event.target.getStage();

      if (
        event.target.getClassName() === 'Circle' ||
        event.target.getClassName() === 'Text'
      ) {
        const markNumber = +event.target.textArr[0].text;
        const mark = this.marks[markNumber - 1];
        const rect = stage.container().getBoundingClientRect();
        this.markInputIdx = mark.idx;
        this.menu = true;
        this.menuPosition = {
          x: rect.left + mark.position.x,
          y: rect.top + mark.position.y,
        };
        return;
      }

      if (this.menu) {
        return;
      }

      const pointerPosition = stage.getPointerPosition();
      const newMark = {
        idx: this.globalMarkIndex,
        bodyPart: bodyPartKey,
        position: {
          x: pointerPosition.x,
          y: pointerPosition.y,
        },
        timestamp: new Date().toISOString(),
        woundType: '',
        description: '',
        dimensions: {
          length: { value: '', unit: 'cm' },
          width: { value: '', unit: 'cm' },
          depth: { value: '', unit: 'cm' },
        },
      };

      this.globalMarkIndex++;
      this.marks.push(newMark);

      const pointer = stage.getPointerPosition();
      const rect = stage.container().getBoundingClientRect();

      this.menuPosition = {
        x: rect.left + pointer.x,
        y: rect.top + pointer.y,
      };
      this.menu = true;
      this.markInputIdx = this.marks.length - 1;
    },
    async loadImages() {
      try {
        const imagePromises = IMAGE_CONFIGS.map(config =>
          this.loadImage(config),
        );
        await Promise.all(imagePromises);
        this.isLoading = false;
      } catch {
        this.isLoading = false;
      }
    },
    loadImage(config) {
      return new Promise((resolve, reject) => {
        const img = new window.Image();
        const src = config.getSrc ? config.getSrc(this.gender) : config.src;
        img.onload = () => {
          img.width = config.width;
          img.height = config.height;
          this.$set(this.backgroundMark, config.key, img);
          resolve();
        };
        img.onerror = reject;
        img.src = src;
      });
    },
    getStageConfig(bodyPartKey) {
      const image = this.backgroundMark[bodyPartKey];
      if (!image) return { width: 0, height: 0 };
      return {
        width: image.width * SCALE_FACTOR,
        height: image.height * SCALE_FACTOR,
      };
    },
    getImageConfig(bodyPartKey) {
      const image = this.backgroundMark[bodyPartKey];
      if (!image) return {};
      return { image, x: IMAGE_OFFSET, y: IMAGE_OFFSET };
    },
    getCircleConfig(item) {
      return {
        x: item.position.x,
        y: item.position.y,
        radius: CIRCLE_RADIUS,
        fill: CIRCLE_COLOR,
        listening: true,
        opacity: 1,
      };
    },
    getTextConfig(item, displayIndex) {
      return {
        x: item.position.x - CIRCLE_RADIUS,
        y: item.position.y - CIRCLE_RADIUS,
        width: CIRCLE_RADIUS * 2,
        height: CIRCLE_RADIUS * 2,
        text: displayIndex.toString(),
        fontSize: 13,
        fontFamily: 'Arial, sans-serif',
        fontStyle: 'normal',
        fill: TEXT_COLOR,
        align: 'center',
        verticalAlign: 'middle',
      };
    },
    getMarksForBodyPart(bodyPartKey) {
      return this.marks.filter(mark => mark.bodyPart === bodyPartKey);
    },

    // Methods that interact with the parent now emit events
    showTooltip(event, item) {
      if (this.tooltipMode !== 'none') return;
      const stage = event.target.getStage();
      const pointer = stage.getPointerPosition();
      const rect = stage.container().getBoundingClientRect();
      this.tooltipPosition = {
        x: rect.left + pointer.x + 10,
        y: rect.top + pointer.y + 10,
      };
      this.hoveredMark = item;
      setTimeout(() => this.showTooltipHelper(item), 100);
    },
    showTooltipHelper(item) {
      if (item?.description && item.description !== '') {
        this.showTooltipVar = true;
      }
    },
    hideTooltip() {
      this.showTooltipVar = false;
      this.hoveredMark = null;
    },
  },
};
</script>

<style lang="scss" scoped>
/* Styles remain unchanged */
.square-rounded-btn {
  border-radius: 5px;
}
.controls {
  display: flex;
  align-items: center;
  gap: 8px;
}
.container-image {
  display: flex;
  flex-direction: column;
  align-items: center;
  .mark-body {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 95%;
  }
  .grid-column {
    margin: 15px 0;
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 15px;
    width: 95%;
    .column {
      display: flex;
      justify-content: center;
      align-items: center;
      padding: 40px 0;
      border: 1px solid #e0e0e0;
      border-radius: 4px;
      transition: border-color 0.2s ease;
    }
  }
}
.outline-img {
  border: 1px solid #e0e0e0;
  border-radius: 4px;
}
</style>
